// StoreKit amounts stay unchanged; dollar currencies place their symbol first.
export function formatStorePrice(micros, currency) {
  const parts = new Intl.NumberFormat('ru-RU', {
    style: 'currency', currency, maximumFractionDigits: micros % 1_000_000 === 0 ? 0 : 2,
  }).formatToParts(micros / 1_000_000)
  const symbol = parts.find(part => part.type === 'currency')?.value
  if (symbol?.includes('$')) return symbol + parts.filter(part => part.type !== 'currency').map(part => part.value).join('').trim()
  return parts.map(part => part.value).join('')
}
